<template>
  <div class="level">
    <svgicon
      name="filter"
      width="30"
      height="30"
      color="#63CCCA"
      :original="true"
      class="level-item filter-icon"
      :class="{ notselected: filterList.length === 0 }">
    </svgicon>
    <div class="level-item">
      <drop-down-auto-complete
        title="Tags"
        label="Filter by Tag"
        :options="tagOptions"
        v-on:dropdown-selection="addTagFilter($event.input)">
      </drop-down-auto-complete>
      <drop-down-auto-complete
        title="Event Type"
        label="Filter by Event Type"
        :options="eventTypeOptions"
        v-on:dropdown-selection="addEventFilter($event.input)">
      </drop-down-auto-complete>
      <!-- <drop-down-auto-complete
        title="Action"
        label="Filter by Action"
        :options="actionOptions"
        v-on:dropdown-selection="addActionFilter($event.input)">
      </drop-down-auto-complete> -->
    </div>
    <div class="tags level-item filter-tags">
      <span
        v-for="filter in filterList"
        :key="filter"
        class="tag is-rounded">
        <span>{{ filter }}</span>
        <a @click="removeFilterTag(filter)" role="button" tabindex="0" class="delete is-small"></a>
      </span>
    </div>
  </div>
</template>

<script>
import _ from 'lodash';
import DropDownAutoComplete from '@/components/DropDownAutoComplete.vue';

export default {
  name: 'AlertLogFilterBar',
  components: { DropDownAutoComplete },
  props: {
    asset: {
      type: Object,
      default: null,
    },
    tagsEndpoint: {
      type: String,
      required: true,
    },
    storeName: {
      type: String,
      required: true,
      validator(value) {
        return ['logViewState', 'alertViewState'].includes(value);
      },
    },
  },
  async mounted() {
    this.tagOptions = await this.updateTags(this.tagsEndpoint);
    // This update is need to trigger the listAlerts request in the Alerts view
    this.$emit('update:filter', this.internalFilter);
  },
  data() {
    return {
      tagOptions: [],
      actionOptions: [
        {
          value: 'Alert',
        },
        {
          value: 'Log',
        },
        {
          value: 'Cache',
        },
      ],
    };
  },
  computed: {
    // Using this instead of a mapState because storeName is a prop
    // https://github.com/vuejs/vuex/issues/863
    filterList() {
      return this.$store.state[`${this.storeName}`].filterList || [];
    },
    eventTypeOptions() {
      return _.map(this.$typeDefs.events, e => ({ value: e.type }));
    },
  },
  methods: {
    addActionFilter(value) {
      this.$store.commit(`${this.storeName}/ADD_FILTER`, `action:${value}`);
    },
    addEventFilter(value) {
      this.$store.commit(`${this.storeName}/ADD_FILTER`, `eventType:${value}`);
    },
    addTagFilter(value) {
      this.$store.commit(`${this.storeName}/ADD_FILTER`, `tag:${value}`);
    },
    addRawFilter(value) {
      this.$store.commit(`${this.storeName}/ADD_FILTER`, value);
    },
    removeFilterTag(value) {
      this.$store.commit(`${this.storeName}/REMOVE_FILTER`, value);
    },
    async updateTags(endpoint) {
      return this.$store.dispatch(endpoint, {
        uuid: this.asset ? this.asset.uuid : null,
        since: '365 days',
      });
    },
    async refreshOptions(endpoint) {
      const labels = await this.$store.dispatch(endpoint);
      if (labels) {
        return labels;
      }
      return [];
    },

  },
};
</script>

<style lang="scss" scoped>

.filter-tags {
  .tag {
    color: $main-background;
    background-color: $expression-background;
  }
}

.level-left .level-item:not(:last-child) {
  &.filter-icon {
    margin-right: 0;
    margin-left: 1rem;
  }
}
</style>
